import React from 'react';
import { BlogPostLayout } from '../blog/BlogPostLayout';
import { BLOG_AUTHORS } from '../blog/authors';
import { BLOG_POSTS } from '../blog/postsMeta';
import { JOURNAL_LAYOUT_STUB_BLOCKS } from '../blog/postContent/journalLayoutStubBlocks';

/** Regression route: inherits BlogPostLayout without forked markup — not linked from journal index. */
export default function BlogJournalLayoutStub() {
  const post = BLOG_POSTS['journal-layout-stub'];
  const author = BLOG_AUTHORS[post.authorId];

  return (
    <BlogPostLayout post={post} author={author} heading="Journal layout stub" blocks={JOURNAL_LAYOUT_STUB_BLOCKS} />
  );
}
